import { render, staticRenderFns } from "./WarrantsBulletin.vue?vue&type=template&id=67d2ef1a&scoped=true&"
import script from "./WarrantsBulletin.js?vue&type=script&lang=js&"
export * from "./WarrantsBulletin.js?vue&type=script&lang=js&"
import style0 from "./WarrantsBulletin.vue?vue&type=style&index=0&id=67d2ef1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d2ef1a",
  null
  
)

export default component.exports